import {useInView} from "react-intersection-observer";
import {useEffect} from "react";
import {useFetchOffers} from "../../../hooks/useOffers";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../shared/Loader";
import {userRoleList} from "../../../utils/constants";
import {OfferCardClient, OfferCardTech} from "./Card";
import {Link} from "react-router-dom";
import {useChatRooms} from "../../../hooks/useChat";
import QueryErrorState from "../shared/QueryErrorState";
import EmptyState from "../shared/EmptyState";

const ListCardOffer = ({filter}) => {
  const {data, isLoading: isMeLoading} = useMe();
  const isClient = data?.selectedRole === userRoleList.CLIENT;
  const queryReady = !!data?.selectedRole && filter?.filter !== null;
  const {data: chatrooms} = useChatRooms(undefined, {enabled: isClient});

  const {
    offers,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useFetchOffers(filter, data?.selectedRole, {enabled: queryReady});

  const {ref, inView} = useInView({
    threshold: 0.1,
  });

  // Fetch the next page when the "inView" changes to true (when the observer hits the bottom of the list)
  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && !isLoading) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, inView, isFetchingNextPage, isLoading]);

  if (!queryReady || isLoading || isMeLoading) {
    return <Loader className={"!relative !bg-transparent"} />;
  }

  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <>
      {isClient &&
        offers.flatPages.length === 0 && (
          <div
            className={`w-full p-6 flex flex-col sm:flex-row gap-7 overflow-hidden relative bg-white rounded-2xl border border-solid border-[#E2E2E2] 
              `}
          >
            <EmptyState className="w-full sm:w-2/5 shrink-0" />
            <div className="flex-grow flex flex-col justify-center items-start gap-2">
              <div className="text-base font-semibold text-[#FF6600]">
                Besoin d’un service à domicile ?
              </div>
              <div className="text-sm text-[#7e7e7e] font-medium ">
                Créez votre 1ère annonce maintenant et trouvez le professionnel
                qu’il vous faut en quelques clics.
              </div>
              <div className=" w-[150px]   ">
                <Link className="" to={"/deposer-une-annonce"}>
                  <button className=" !p-0 w-full h-[32px] gap-2  rounded-lg text-base flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white ">
                    <i className="fi fi-rr-multiple flex items-center"></i>{" "}
                    <span className="font-bold text-[12px]">Commencer</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      {!isClient && offers.flatPages.length === 0 && (
        <div className="w-full min-h-[300px] rounded-2xl bg-white p-6 flex flex-col items-center justify-center gap-2 text-center">
          <EmptyState className="w-full" />
          {/* Keep this copy for screen readers; the visual state is the shared animation. */}
          <div className="sr-only">
          <div className="font-semibold text-[#19295C]">
            Aucune annonce disponible pour le moment
          </div>
          <div className="max-w-md text-sm text-[#7E7E7E]">
            Les nouvelles annonces correspondant à vos secteurs et compétences
            apparaîtront ici automatiquement.
          </div>
          </div>
        </div>
      )}
      {offers.flatPages.map((offer, index) => (
        <div className="w-full " key={offer?.id}>
          {isClient ? (
            <OfferCardClient
              offer={offer}
              chatrooms={(chatrooms ?? []).filter(
                (el) => el?.indirectChat?.offerId === offer.id,
              )}
            />
          ) : (
            <OfferCardTech offer={offer} technicianID={data.Technician.id} />
          )}
        </div>
      ))}
      {/* Loader for fetching more data */}
      {isFetchingNextPage && (
        <div className="w-full">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      )}
      {/* Sentinel for infinite scrolling */}
      <div ref={ref} className="w-full mb-4">
        {hasNextPage ? (
          <div className="w-full text-center">
            Chargement de plus d'offres...
          </div>
        ) : offers?.flatPages?.length > 4 ? (
          <div className="w-full text-center">Fin de résultats.</div>
        ) : null}
      </div>
    </>
  );
};

export default ListCardOffer;
